import React, {useEffect, useState} from "react";
import AccountService from "../../../services/account.service";
import RoleMultiSelect from "./RoleMultiSelect";
import {toast} from "react-hot-toast";

const EditUserModal = ({user, onClose, onUpdated, roles}) => {
    const [form, setForm] = useState({
        userId: null,
        firstName: null,
        lastName: null,
        email: null,
        isActive: null,
        lastLogin: null,
        roleList: [],
        roleListId: [],
        roleListIds: [],
        roleListIdStr: null
    });
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (user) {
            const roleNames = user.roleList ? user.roleList.split(', ').map(r => r.trim()) : [];
            const roleIds = user.roleListIds ? user.roleListIds.split(', ').map(id => id.trim()) : [];
            setForm({
                userId: user.userId,
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                isActive: user.isActive,
                lastLogin: user.lastLogin,
                roleList: roleNames,
                roleListId: [],
                roleListIds: roleIds,
                roleListIdStr: ""
            });
        }
    }, [user]);
    const handleChange = (e) => {
        const {name, value} = e.target;
        setForm(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const handleRolesChange = ({roleList, roleListIds}) => {
        setForm(prev => ({
            ...prev,
            roleList: roleList,
            roleListIds: roleListIds
        }));
    }

    const handleUpdate = async (e) => {
        e.preventDefault();
        setSaving(true);
        const payload = {
            ...user,
            firstName: form.firstName,
            lastName: form.lastName,
            roleList: form.roleList.join(', '),
            roleListIds: form.roleListIds.join(', '),
        };
        const promise = AccountService.updatelifewhereuser(payload);

        toast.promise(promise, {
            loading: 'Sending changes...',
            success: 'The user was updated successfully!',
            error: (err)=> err.message || 'Error updating user'
        });
        
        try {
            await promise;
        }catch(error) {
            console.log(error);
        }finally {
            setSaving(false);
            onUpdated();
            onClose();
        }
    };
    
    return (
        <div className="modal" style={{display: user ? "block" : "none"}}>
            <div className="modal-wrapper"
                 style={{
                     transform: user ? 'translateY(0vh)' : 'translateY(-100vh)',
                     opacity: user ? '1' : '0'
                 }}>

                <div className="modal-header">
                    <h3>Edit User</h3>
                    <span className="close-modal-btn" onClick={onClose}>×</span>
                </div>

                <div className="px-3 py-3 text-start">
                    <br/>
                    {user ? (
                        <form onSubmit={handleUpdate}>
                            <div className="row">
                                <div className="col-sm-12 col-md-6">
                                    <div>
                                        <p className="semibold">First Name</p>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="firstName"
                                            id="firstName"
                                            onChange={handleChange}
                                            defaultValue={form.firstName}
                                        />
                                    </div>
                                    <div>
                                        <p className="semibold">Last Name</p>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="lastName"
                                            id="lastName"
                                            onChange={handleChange}
                                            defaultValue={form.lastName}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <div>
                                        <p className="semibold">Type</p>
                                        <RoleMultiSelect roles={roles} value={form} onChange={handleRolesChange}/>
                                    </div>
                                </div>
                            </div>
                            <br/>
                            <div className="modal-footer">
                                <button type="button" className="secondary-btn btn-small" onClick={onClose}
                                        disabled={saving}>Cancel
                                </button>
                                <button type="submit" className="primary-btn btn-small" disabled={saving}>Save</button>
                            </div>
                        </form>
                    ) : (
                        <div>Loading...</div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default EditUserModal;